// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rtl-stepper[data-v-2d2bc830]{direction:rtl}.rtl-stepper[data-v-2d2bc830],.v-stepper[data-v-2d2bc830] .v-stepper__header{-webkit-box-shadow:none!important;box-shadow:none!important}.v-stepper[data-v-2d2bc830] .v-stepper__header{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.rtl-stepper .v-stepper__step[data-v-2d2bc830]{text-align:right}", ""]);
// Exports
module.exports = exports;
